import { render, staticRenderFns } from "./AdminOptions.vue?vue&type=template&id=62c54476&scoped=true"
import script from "./AdminOptions.vue?vue&type=script&lang=ts"
export * from "./AdminOptions.vue?vue&type=script&lang=ts"
import style0 from "./AdminOptions.vue?vue&type=style&index=0&id=62c54476&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62c54476",
  null
  
)

export default component.exports